import React from 'react'
import bannerImg1 from '../../images/limousine.jpg'
import bannerImg2 from '../../images/hotelTaxi.jpg'
import bannerImg3 from '../../images/banner5.jpg'
import bannerImg4 from '../../images/banner4.jpg'
import bannerImg5 from '../../images/wheelchairTaxi.jpg'
import bannerImg6 from '../../images/airport.jpg'
import bannerImg7 from '../../images/businessTaxi.jpg'
import bannerImg8 from '../../images/bannerImg8.jpg'
import bannerImg9 from '../../images/banner9.svg'
import bannerImg10 from '../../images/banner10.jpg'
import ServiceCard from '../../components/ServiceCard/ServiceCard'
const cards = [
    {
      img: bannerImg1,
      title: "Premium White Limousine Services in Leduc",
      desp: "Elevate your travel experience with White Cabs' luxurious white limousine service in Leduc, AB. Perfect for special events, holidays, or everyday journeys, our eco-friendly limos come equipped with complimentary WiFi. Enjoy a flat-rate ride to Leduc Airport or downtown. Let us make your occasion unforgettable!",
      link: "/service/white-limousine-service"
    },
    {
      img: bannerImg2,
      title: "Reliable Hotel Taxi Services in Leduc",
      desp: "Visiting Leduc? Enjoy hassle-free hotel taxi services with White Cabs. Whether it's an airport transfer, shopping trip, or business meeting, our sanitized fleet of sedans, SUVs, and tempos is at your service. Experience affordability, reliability, and comfort during your stay.",
      link: "/service/hotel-taxi"
    },
    {
      img: bannerImg3,
      title: "Flexible On-Demand Delivery in Leduc",
      desp: "White Cabs makes item delivery easy with on-demand services across Leduc. From food to shopping and courier needs, we've got you covered. Our flexible delivery options also extend to surrounding areas, including Coaldale and Fort Macleod. Call us for a seamless delivery experience.",
      link: "/service/shopping-taxi-service"
    },
    {
      img: bannerImg4,
      title: "Convenient Shopping Taxi Services in Leduc",
      desp: "Planning a shopping trip in Leduc? White Cabs offers flat-rate taxi services to malls, restaurants, and other destinations. Our sanitized fleet includes wheelchair-accessible vans, ensuring everyone can shop in comfort and style. Call us to book your ride today!",
      link: "/service/shopping-taxi-service"
    },
    {
      img: bannerImg5,
      title: "Specialized Wheelchair Taxi Services in Leduc",
      desp: "White Cabs provides dedicated wheelchair taxi services for passengers with mobility aids. Available seven days a week, our vehicles ensure safe and comfortable transportation for medical appointments, airport transfers, and more. Your convenience is our priority.",
      link: "/service/wheelchair-van"
    },
    {
      img: bannerImg6,
      title: "Reliable Airport Taxi Services in Leduc",
      desp: "White Cabs offers dependable airport taxi services 24/7 with flat-rate pricing. Whether traveling alone or in a group, our fleet of sedans, SUVs, and tempos ensures a smooth and hassle-free journey to and from Leduc Airport.",
      link: "/service/airport-taxi"
    },
    {
      img: bannerImg7,
      title: "Corporate Business Taxi Services in Leduc",
      desp: "Experience professionalism with White Cabs' business taxi services. From corporate accounts to executive vehicles, we offer tailored solutions for office pickups and airport transfers. Book online or by phone for timely and luxurious rides.",
      link: "/service/business-taxi"
    },
    {
      img: bannerImg8,
      title: "24/7 Taxi Services in Leduc",
      desp: "Day or night, White Cabs operates round-the-clock to meet your transportation needs in Leduc. Our experienced drivers ensure a safe and comfortable ride, offering flat-rate services for personal, business, or leisure travel. Book now at whitecabs.ca.",
      link: "/service/24-7-taxi"
    },
    {
      img: bannerImg9,
      title: "Flat-Rate Taxi Services in Leduc",
      desp: "Simplify your travel plans with White Cabs' flat-rate taxi services in Leduc. Ideal for airport transfers, shopping trips, or sightseeing, our sanitized fleet of vehicles guarantees comfort and convenience. Book your flat-rate taxi today!",
      link: "/service/flat-taxi"
    },
    {
      img: bannerImg10,
      title: "24/7 Emergency Car Boosting in Leduc",
      desp: "Stranded with a dead battery? White Cabs offers 24/7 emergency car boosting services in Leduc. Whether you're at home, work, or on the road, our team provides quick and reliable assistance to get you back on track.",
      link: "/service/car-boosting-service"
    }
  ];
  

  const Service = () => {
    return (
      <div className="blog container">
        <h2 className="title">Discover Our Top Services in Leduc</h2>
        <div className="blog__container">
          {cards.map((elm, i) => (
            <ServiceCard key={i} elm={elm} />
          ))}
        </div>
      </div>
    );
  };
  

export default Service